import DialogBox from "../../../Popups/ReusablePopup/DialogBox";
import { useSelector, useDispatch } from "react-redux";
import FormikTextField from "../../../../../Common/FormFields/FormikInputField";
import { Form, Formik } from "formik";
import validationSchema from "../../../../../Validation/ValidationSchemas";
import { getFromLocalStorage } from "../../../../../utils/webStorage";
import { addNewFilter } from "../../../../../Redux/Actions/VideoLibraryFilterAction";
const AddToQuickFilter = ({
  currentFilterList,
  isAddToQuickFilter,
  setIsAddToQuickFilter,
  setCurrentFilterList,
}) => {
  const dispatch = useDispatch();
  const schoolId = getFromLocalStorage("schoolId");
  const activeBreakDownList = useSelector(
    (state) => state?.VideoLibraryDataTable?.activeBreakDownList
  );
  const closeDialogBox = () => {
    setIsAddToQuickFilter(false);
  };

  const getConditionName = (operator) => {
    switch (operator) {
      case "===":
        return "EqualTo";
      case ">":
        return "GreaterThan";
      case "<":
        return "LessThan";
      case "...":
        return "Between";
      case "!==":
        return "NotEqualTo";
      default:
        return;
    }
  };

  const handleSubmit = async (values) => {
    const names = Object.values(values);
    setCurrentFilterList((prevValues) =>
      prevValues.map((ele, index) => {
        return { ...ele, filterName: names[index] };
      })
    );
    currentFilterList.forEach((item, index) => {
      const breakdownData = activeBreakDownList.filter((ele) => {
        return ele.breakdownName === item.breakDownName;
      });
      const updatedValue = item.value.join(",");
      const conditionName = getConditionName(item.operator);
      addNewFilter(dispatch, {
        filterName: names[index],
        breakDownName: breakdownData[0]?.id,
        conditionName: conditionName,
        conditionValue: updatedValue,
        schoolId: schoolId,
      });
    });
    setIsAddToQuickFilter(false);
  };
  return (
    <>
      <DialogBox
        open={isAddToQuickFilter}
        onClose={closeDialogBox}
        variant="xs"
        title={
          <div className="d-flex-space-between">
            <p className="bold">Add filter name</p>
            <button
              className="breakdownTableCloseIcon"
              onClick={closeDialogBox}
            >
              <span>&times;</span>
            </button>
          </div>
        }
      >
        <Formik
          initialValues={{
            ...currentFilterList.reduce((acc, _, index) => {
              acc[`filterName${index + 1}`] = "";
              return acc;
            }, {}),
          }}
          validationSchema={validationSchema.AddToQuickFilterSchema}
          onSubmit={handleSubmit}
        >
          {(formik) => (
            <Form>
              {currentFilterList.map((_, index) => (
                <FormikTextField
                  key={index}
                  label={`Filter name ${index + 1}`}
                  formik={formik}
                  fieldName={`filterName${index + 1}`}
                  placeholder="Enter filter name"
                  labelFontSize="fs-18"
                />
              ))}
              <div className="d-flex-align-right">
                <button
                  className={formik.isValid ? "saveBtn1" : "saveBtn1 activv"}
                  type="submit"
                  disabled={!formik.isValid}
                >
                  Add
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </DialogBox>
    </>
  );
};

export default AddToQuickFilter;
